export default __webpack_public_path__ + "static/media/penjualan-digital.80cc6347.png";